import { Helmet } from 'react-helmet'
import React from 'react'
import { PUBLIC_LINK_BASE } from 'variables/general'

function PortfolioHelmet(props) {
  let city = props.photographer.location.name
  let photographer = props.photographer

  const titleString = city
    ? `${props.photographer.companyName}'s ${props.activeTag} Portfolio - ${city}`
    : `${props.photographer.companyName}'s ${props.activeTag} Portfolio`

  const urlTag = (tag) => {
    return tag.replaceAll(' ', '-')
  }

  let canonicalLink =
    props.photographer.nextCustomDomain && props.photographer.activeWebsite
      ? `https://${props.photographer.nextCustomDomain}/pricing`
      : props.photographer.login && props.photographer.activeWebsite
      ? `https://${props.photographer.login}.website.bookfocal.com/pricing`
      : props.photographer.domain
      ? `https://app.bookfocal.com/portfolio/${props.photographer.identifier}/${urlTag(props.activeTag)})
      `
      : `https://app.bookfocal.com/marketplace-portfolio/${props.photographer.identifier}/${urlTag(
          props.activeTag,
        )})
      `

  return (
    <Helmet>
      <title>{titleString}</title>
      <meta
        name="description"
        content={
          'Browse ' +
          props.photographer.companyName +
          "'s " +
          props.activeTag +
          ' Portfolio and Photography Packages'
        }
      />
      {/*Open Graph*/}
      <meta property="og:title" content={props.photographer.companyName + "'s " + props.activeTag} />
      <meta
        property="og:description"
        content={props.photographer.companyName + "'s " + props.activeTag + ' Portfolio'}
      />
      <meta property="og:url" content={`${PUBLIC_LINK_BASE(photographer)}${props.location.pathname}`} />
      <meta property="og:image" content={props.photographer.companyImage} />
      <link rel="canonical" href={canonicalLink} />
    </Helmet>
  )
}

export default PortfolioHelmet
